import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { LoginInformation } from './LoginInformation';
import { PersonalDetailsForm } from './PersonalDetailsForm';
import { useContext } from 'react';
import { OTPLoginContext } from 'Context/OTPLoginContext';
import { PhoneEmailValidation } from './PhoneEmailValidation';

export const OTPFormStepper = () => {
  const isDesktop = useIsDesktop();

  const { step } = useContext(OTPLoginContext);
  const stepper: React.ReactNode[] = [
    <LoginInformation />,
    <PersonalDetailsForm />,
    <PhoneEmailValidation />,
  ];

  return (
    <Stack alignItems={'center'}>
      <Stack
        bgcolor={isDesktop ? 'primary.shade_100' : undefined}
        border={isDesktop ? '1px solid' : undefined}
        borderColor={'primary.shade_200'}
        borderRadius='20px'
        boxShadow={isDesktop ? '1px 2px 24px rgba(8, 30, 84, 0.06)' : undefined}
        maxWidth='770px'
        paddingTop={'32px'}
        paddingBottom={'48px'}
        alignItems={'center'}
      >
        {stepper[step]}
      </Stack>
    </Stack>
  );
};
